import { Link, useNavigate } from "react-router-dom";
import { Trash } from "@phosphor-icons/react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { formatGP } from "@/lib/format";

export default function CartDrawer() {
  const { items, remove, total, open, setOpen } = useCart();
  const nav = useNavigate();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="bg-[#080808] border-l border-[#ff2a55]/40 text-white w-[min(440px,100vw)] flex flex-col" data-testid="cart-drawer">
        <SheetHeader>
          <SheetTitle className="font-display text-3xl text-white">Your payload <span className="hot-text">({items.length})</span></SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto space-y-3 py-4" data-lenis-prevent>
          {items.length === 0 && <div className="text-[#777] text-sm py-12 text-center" data-testid="cart-empty">Nothing locked in yet. Pick a target.</div>}
          {items.map((it) => (
            <div key={it.id} className="flex items-center justify-between border border-white/10 bg-[#0e0e0e] p-4" data-testid={`cart-item-${it.id}`}>
              <div>
                <div className="font-display text-2xl chrome-text-sm leading-none">{it.title}</div>
                <div className="text-[11px] tracking-[0.2em] uppercase text-[#777] mt-1">{it.category.replace("-", " ")}</div>
              </div>
              <div className="flex items-center gap-4">
                <span className="font-display text-xl hot-text">{formatGP(it.price)}</span>
                <button onClick={() => remove(it.id)} className="text-[#777] hover:text-[#ff2a55] transition-colors" aria-label="Remove" data-testid={`cart-remove-${it.id}`}><Trash size={18} /></button>
              </div>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10 pt-4 space-y-4">
          <div className="flex justify-between items-end"><span className="overline-label">Total</span><span className="font-display text-4xl hot-text" data-testid="cart-total">{formatGP(total)} GP</span></div>
          <button className="btn-bomb w-full" disabled={!items.length} onClick={() => { setOpen(false); nav("/checkout"); }} data-testid="cart-checkout-button">Detonate checkout</button>
          <Link to="/shop" onClick={() => setOpen(false)} className="block text-center text-xs tracking-[0.2em] uppercase text-[#888] hover:text-white transition-colors">Keep browsing</Link>
        </div>
      </SheetContent>
    </Sheet>
  );
}
